export var onRequestConfig = function onRequestConfig(config) {
  var token = localStorage.getItem("token");
  if (token) config.headers.token = token;
};
export var onRequestConfigError = function onRequestConfigError(error) {
  //console.log(error)
};
export var onNoServerResponse = function onNoServerResponse(error) {
  //console.log(error)
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var onResponse = function onResponse(response) {
  // This is an empty function.
};
export var onResponseError = function onResponseError(uiStore, error) {
  var _error$response, _error$response2;
  //console.log("this: ", this)
  //const _this: any = this
  //_this.rootStore.uiStore.handleSpinner(--this.rootStore.uiStore.numberCallback);
  //console.log("error: ", error)
  switch (error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) {
    case 400:
      // console.debug("400: ", 400)
      // uiStore.addDangerMessage({ "text": "Il servizio non è al momento disponibile, riprovare più tardi o contattare l'assistenza." })
      break;
    case 401:
      //_this.rootStore.uiStore.handleSpinner(--this.rootStore.uiStore.numberCallback);
      //window.location.href = process.env.CONTEXT_PATH + "/progetti"
      //window.location.href = process.env.CONTEXT_PATH + "/error"
      break;
    case 503:
      console.debug("503: ", 503);
      uiStore.addDangerMessage({
        "text": "Il servizio non è al momento disponibile, riprovare più tardi o contattare l'assistenza."
      });
      break;
    default:
      //_this.rootStore.uiStore.handleSpinner(--this.rootStore.uiStore.numberCallback);
      //TODO verificare se insieme al codice http di errore ci sia anche un messaggio valorizzato nell'header
      var msg = "Si è verificato un errore. Riprovare più tardi.";
      var msgHeader = error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.headers) === null || _error$response2 === void 0 ? void 0 : _error$response2.msg;
      if (msgHeader !== undefined && msgHeader !== null && msgHeader !== "") msg = msgHeader;

      //_this.rootStore.uiStore.addDangerMessage({"text": msg})
      break;
  }
};